<script>
  /* Stores */
  import storeGlobal from "../../stores/storeGlobal";

  /* Constants */
  import URL from "../../constants/url";

  /* Components */
  import Medium from "./Medium.svelte";

  /* Variables */
  export let lazy;
  export let color;

  const {
    name,
    medium,
    pigments,
    photoBefore,
    producer,
    line,
    colorFamily
  } = color;

  const toggleModal = (color) => {
    storeGlobal.updateItem('showDetails', true);
    storeGlobal.updateItem('detailColor', color);
  }
</script>

{#if lazy}
  <li class="border
             border-smoke
             rounded-lg
             overflow-hidden
             cursor-pointer
             hover:shadow-lg
             transition
             duration-200
             bg-white
             dark:bg-steel
             dark:border-blackd"
      on:click="{ toggleModal(color) }">

    <!-- card Image -->
    <div class="relative">
      <!-- Icon -->
      <div class="absolute right-0 top-0 bg-blackd rounded-full p-2 m-2">
        <Medium { medium } />
      </div>

      <img class="w-full object-cover" alt="{ name }" src="{URL}/{photoBefore.url}"/>
    </div>

    <!-- card content -->
    <div class="p-4">

      <!-- Pigments -->
      <div class="text-xs
                  uppercase
                  text-silver
                  font-semibold
                  tracking-wide
                  truncate">
        { pigments }
      </div>

      <!-- colorname -->
      <h4 class="font-semibold
                 text-lg
                 leading-tight
                 truncate
                 mt-2
                 dark:text-smoke_xd">
        { name }
      </h4>

      <!-- producer & line -->
      <div class="mt-2
                  text-sm
                  dark:text-silver">

        <p class="font-bold">
          { producer }
        </p>

        <p class="truncate">
          { line }
        </p>
      </div>

    </div>
  </li>
{/if}
